import React from 'react';

function AgentFilter({
  openModal = () => {},
  clearSelection = () => {},
  inputValue,
  label = 'Agent Filter',
}) {
  return (
    <>
      <label htmlFor="agent-filter" className="form-label">
        {label}
      </label>
      <div className="input-group">
        <input
          disabled
          className="form-control"
          value={inputValue}
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={() => openModal()}
        >
          Select
        </button>
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={() => clearSelection()}
        >
          Clear
        </button>
      </div>
    </>
  );
}

export default AgentFilter;
